<template>
  <div class="rich-text-editor">
    <div class="toolbar">
      <v-btn
        small
        text
        @click="execCommand('bold')"
        :class="{ active: isBold }"
      >
        <v-icon small>mdi-format-bold</v-icon>
      </v-btn>
      <v-btn
        small
        text
        @click="execCommand('italic')"
        :class="{ active: isItalic }"
      >
        <v-icon small>mdi-format-italic</v-icon>
      </v-btn>
      <v-btn
        small
        text
        @click="execCommand('underline')"
        :class="{ active: isUnderline }"
      >
        <v-icon small>mdi-format-underline</v-icon>
      </v-btn>
    </div>
    <div
      ref="editor"
      contenteditable="true"
      :class="['editor-content', { 'single-line': singleLine }]"
      @input="handleInput"
      @blur="handleBlur"
      @keydown.enter.shift.exact.prevent="!singleLine && insertLineBreak()"
      @keydown.enter.exact.prevent="!singleLine && insertParagraph()"
      @keydown.enter.exact="singleLine && $event.preventDefault()"
    ></div>
  </div>
</template>

<script>
export default {
  name: "RichTextEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
    singleLine: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.value || "",
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.localValue) {
        this.localValue = newVal || "";
        this.updateEditorContent();
      }
    },
  },
  mounted() {
    this.updateEditorContent();
  },
  computed: {
    isBold() {
      return document.queryCommandState("bold");
    },
    isItalic() {
      return document.queryCommandState("italic");
    },
    isUnderline() {
      return document.queryCommandState("underline");
    },
  },
  methods: {
    updateEditorContent() {
      if (this.$refs.editor) {
        const content = this.localValue || "";
        this.$refs.editor.innerHTML = content;
      }
    },
    handleInput() {
      this.localValue = this.$refs.editor.innerHTML;
      this.$emit("input", this.localValue);
    },
    handleBlur() {
      this.localValue = this.$refs.editor.innerHTML;
      this.$emit("input", this.localValue);
    },
    execCommand(command) {
      this.$refs.editor.focus();
      document.execCommand(command, false, null);
      this.handleInput();
    },
    insertLineBreak() {
      document.execCommand("insertHTML", false, "<br>");
      this.handleInput();
    },
    insertParagraph() {
      document.execCommand("insertHTML", false, "<br>");
      this.handleInput();
    },
  },
};
</script>

<style scoped lang="scss">
.rich-text-editor {
  border: 1px solid #23919e;
  border-radius: 4px;
  background-color: white;
}

.toolbar {
  display: flex;
  gap: 4px;
  padding: 4px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #23919e;

  .v-btn {
    min-width: 36px;
  }

  .v-btn.active {
    background-color: #23919e;
    color: white;
  }
}

.editor-content {
  min-height: 120px;
  padding: 12px;
  outline: none;
  overflow-y: auto;
  line-height: 1.5;
  font-size: 14px;
  font-family: inherit;
  word-wrap: break-word;

  &:empty:before {
    content: attr(placeholder);
    color: #999;
    pointer-events: none;
  }

  &.single-line {
    min-height: 40px;
    max-height: 40px;
    padding: 8px;
    overflow-y: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
